import React from "react";
import UsersCommon from "../UsersMain";

const PaidUsers = () => {
  const type = "Paid";
  const title = "Paid users";
  return <UsersCommon type={type} title={title} />;
};

export default PaidUsers;
